if (!customElements.get('product-badge')) {
  customElements.define(
    'product-badge',
    class extends HTMLElement {
      constructor() {
        super();
        try {
          this.config = JSON.parse(this.dataset.config || '{}');
        } catch (e) {
          this.config = this.dataset.config || '';
        }
      }

      connectedCallback() {
        if (!this.config) {
          console.warn('Product badge config is not set or invalid.');
          return;
        }

        const productBadge = this.querySelector('.product__badge');

        if (this.config.url) {
          productBadge.classList.add('product__badge--link');

          this.addEventListener('click', (event) => {
            event.preventDefault();
            window.location.href = this.config.url;
          });
        }

        productBadge.innerHTML = this.config.text || this.config;
      }
    }
  );
}
